import React, { useEffect, useState } from "react";
import {InformationCircleIcon, AdvantageCheckIcon } from "../../common/icons";

const ProductBox = ({ languages }) => {
  
  return (
    <>
      <div className={`product-box`}>
        <div className="title-header flex mt-2 mb-3">
            <div className="benefits-icon flex mx-3 content-center items-center">
                <InformationCircleIcon className="w-6 h-6" />
            </div>
            <div className="title-header-text text-lg font-montserrat font-semibold">
                <p>{languages?.joinNow || "Join now and get extra benefits"}</p>
            </div>
        </div>
        <ul className="benefits">
            <li className="benefits-list">
                <div className="benefits-holder flex">
                    <div className="benefits-icon flex mx-3 content-center items-center">
                        <AdvantageCheckIcon className="w-6 h-6" />
                    </div>
                    <div className="benefits-content py-1">
                        <p>{languages.benefitOne
                                ? languages.benefitOne
                                : "14 months for the price of 12 months"}</p>
                    </div>
                </div>
            </li>
            {/* Removed -Requested from Marketing 15/07/25 */}
            {/* <li className="benefits-list">
                <div className="benefits-holder flex">
                    <div className="benefits-icon flex mx-3 content-center items-center">
                        <AdvantageCheckIcon className="w-6 h-6" />
                    </div>
                    <div className="benefits-content py-1">
                        <p>{languages.benefitTwo
                                ? languages.benefitTwo
                                : "2,000 bonus reward points"}</p>
                    </div>
                </div>
            </li> */}
            <li className="benefits-list">
                <div className="benefits-holder flex">
                    <div className="benefits-icon flex mx-3 content-center items-center">
                        <AdvantageCheckIcon className="w-6 h-6" />
                    </div>
                    <div className="benefits-content py-1">
                        <p>{languages.benefitThree
                                ? languages.benefitThree
                                : "Enjoy a free upgrade to ALL Accor+ Explorer from 1 October, 2025."}</p>
                    </div>
                </div>
            </li>
        </ul>
      </div>
    </>
  );
};

export default ProductBox;
